import { render, staticRenderFns } from "./ribbons.vue?vue&type=template&id=d817c176&"
import script from "./ribbons.vue?vue&type=script&lang=js&"
export * from "./ribbons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports